import { requestAndParse, requestSuccessful } from '../request';

const addSlideToStudy = async (studyId: number, slideId: number) => {
    const route = 'admin/add-slide-to-study';
    const payload = { studyId, slideId };

    const response = await requestAndParse(route, payload, 'POST');

    const success = requestSuccessful(response);

    return success;
};

export default addSlideToStudy;
